/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whats_New_Internal_SectionInputs */

const vi_whats_new_internal_section = /** @type {(inputs: Whats_New_Internal_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghi chú nội bộ`)
};

/**

* @param {Whats_New_Internal_SectionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const whats_new_internal_section = /** @type {((inputs?: Whats_New_Internal_SectionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whats_New_Internal_SectionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_whats_new_internal_section(inputs)
});